export default "__VITE_ASSET__Bo4yZ4M8__"